"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingBillingStatusEnum = void 0;
/** Статус оплаты участия в митинге, а также самого митинга */
var MeetingBillingStatusEnum;
(function (MeetingBillingStatusEnum) {
  /** не оплачено */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["unpaid"] = 0] = "unpaid";
  /** оплачено */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["paid"] = 1] = "paid";
  /** бесплатно */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["free"] = 2] = "free";
  /** в процессе оплаты */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["processing"] = 3] = "processing";
  /** возвращено */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["refunded"] = 4] = "refunded";
  /** не удалось */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["failed"] = 5] = "failed";
  /** оплата заблокирована на счету */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["blocked"] = 6] = "blocked";
  /** в процессе отмены */
  MeetingBillingStatusEnum[MeetingBillingStatusEnum["cancelling"] = 7] = "cancelling";
})(MeetingBillingStatusEnum = exports.MeetingBillingStatusEnum || (exports.MeetingBillingStatusEnum = {}));
